module.exports = {
    YEAR: 'YEAR',
    STATUS: 'STATUS',
    COLLECTIVITY: 'COLLECTIVITY',

    INCOMPLETE: {
        name: 'incomplete',
        color: '#fea953',
        bgColor: '#f8f7e2',
    },
    VALIDATED: {
        name: 'validated',
        color: '#3aa94b',
        bgColor: '#e3f2e9',
    },
    IN_PROGRESS: {
        name: 'inProgress',
        color: '#2196f3',
        bgColor: '#e3f2fd',
    },
    PENDING_VALIDATION: {
        name: 'pendingValidation',
        color: '#edd314',
        bgColor: '#faf5e0',
    },
    DRAFT: {
        name: 'draft',
        color: '#edd314',
        bgColor: '#faf5e0',
    },
    PUBLISHED: {
        name: 'published',
        color: '#edd314',
        bgColor: '#faf5e0',
    },
    FROZEN: {
        name: 'frozen',
        color: '#edd314',
        bgColor: '#faf5e0',
    },
    DELIBERATION_PENDING: {
        name: 'deliberationPending',
        color: '#edd314',
        bgColor: '#faf5e0',
    },
    VERIFIED_DDTM: {
        name: 'verifiedDDTM',
        color: '#edd314',
        bgColor: '#faf5e0',
    },
    TRANSFERRED_SYSPEA: {
        name: 'transferredSYSPEA',
        color: '#edd314',
        bgColor: '#faf5e0',
    },

    SUBSCRIBER: 'subscriber',
    SUBSCRIBER_COLOR: '#496fce',
    NETWORK: 'network',
    NETWORK_COLOR: '#97b0f0',
    QUALITY: 'quality',
    QUALITY_COLOR: '#82cfff',
    FINANCIAL: 'financial',
    FINANCIAL_COLOR: '#102d76',

    GREY_BG: '#e3e6eb',
    HOVER_COLOR_ROW: '#f5f5f5',

    // ************* Zones *************
    ZONE_SELECTION_INDEX: -1,

    DELETE_ZONE: 'delete',
    ADD_ZONE: 'add',

    DEFAULT_SUB_TRANCHE: [
        {
            name: 'Compteur DN 25',
            isImportant: true,
        },
        {
            name: 'Compteur DN 15',
            isImportant: false,
        },
        {
            name: 'Compteur DN 30',
            isImportant: false,
        },
    ],

    DEFAULT_CONSO_TRANCHE: [
        {
            name: 'Tr.1 0-50 m3',
            isImportant: true,
        },
        {
            name: 'Tr.2 0-50 m3',
            isImportant: true,
        },
        {
            name: 'Tr.3 0-50 m3',
            isImportant: false,
        },
    ],

    RPQS_STATUSES: [
        { code: 0, name: 'rpqsStatusWaitingInput', color: '#fea953', bgColor: '#f8f7e2', dateField: 'waitingInputDate' },
        { code: 1, name: 'rpqsStatusInputInProgress', color: '#2196f3', bgColor: '#e3f2fd', dateField: 'inputInProgressDate' },
        { code: 2, name: 'rpqsStatusWaitingVerification', color: '#edd314', bgColor: '#faf5e0', dateField: 'waitingVerificationDate' },
        { code: 3, name: 'rpqsStatusVerificationInProgress', color: '#9c27b0', bgColor: '#f3e5f5', dateField: 'verificationInProgressDate' },
        { code: 4, name: 'rpqsStatusVerified', color: '#3aa94b', bgColor: '#e3f2e9', dateField: 'verifiedDate' },
        { code: 5, name: 'rpqsStatusPublished', color: '#00796b', bgColor: '#e0f2f1', dateField: 'publishedDate' },
    ],

    // ************* Compétences exercées d'une entité de gestion *************
    MANAGEMENT_MODE: {
        SINGLE: 1,
        MULTIPLE: 2,
    },
    // codes du lexique ENTITE_GESTION.COMPETENCE
    MANAGEMENT_TYPE: {
        REGIE: 1,
        DELEGATION: 2,
    },

    // ************* Indicators *************
    CHECKBOX: 'checkbox',

    // typechamp d'un indicateur (rpqs_indicateurs_ref)
    FIELD_TYPE_INT: 'int',
    FIELD_TYPE_FLOAT: 'float',
    FIELD_TYPE_BOOL: 'bool',

    D102_1: {
        code: 'D102.1',
        name: 'D102.1',
        i18n: 'servicePrice',
    },

    D101_0: {
        code: 'D101.0',
        name: 'D101.0',
        i18n: 'nbPeopleServed',
    },

    P155_1_RATE: {
        code: 'P155.1',
        name: 'P155.1',
        i18n: 'claimsRate',
    },

    P152_1: {
        code: 'P152.1',
        name: 'P152.1',
        i18n: 'complianceWithDeadlines',
    },

    D151_0: {
        code: 'D151.0',
        name: 'D151.0',
        i18n: 'maxContractualConnectionTime',
    },

    P151_1: {
        code: 'P151.1',
        name: 'P151.1',
        i18n: 'interruptionsFrequency',
    },

    P106_3: {
        code: 'P106.3',
        name: 'P106.3',
        i18n: 'networkLosses',
    },

    P104_3: {
        code: 'P104.3',
        name: 'P104.3',
        i18n: 'distributionNetworkEfficiency',
    },

    P105_3: {
        code: 'P105.3',
        name: 'P105.3',
        i18n: 'unmeteredVolumes',
    },

    P107_2: {
        code: 'P107.2',
        name: 'P107.2',
        i18n: 'renewalWaterNetwork',
    },

    P103_2B: {
        code: 'P103.2B',
        name: 'P103.2B',
        i18n: 'knowledgeDrinkingWaterNetwork',
    },

    P102_1: {
        code: 'P102.1',
        name: 'P102.1',
        i18n: 'phyisochemicalConformityWater',
    },

    P101_1: {
        code: 'P101.1',
        name: 'P101.1',
        i18n: 'microbiologicalConformityWater',
    },

    P108_3: {
        code: 'P108.3',
        name: 'P108.3',
        i18n: 'protectingWaterResources',
    },

    P153_2: {
        code: 'P153.2',
        name: 'P153.2',
        i18n: 'debtPeriod',
    },

    P154_0: {
        code: 'P154.0',
        name: 'P154.0',
        i18n: 'rateOfUnpaidBills',
    },

    P109_0: {
        code: 'P109.0',
        name: 'P109.0',
        i18n: 'solidarityActions',
    },

    VP_056: {
        code: 'VP.056',
        name: 'VP.056',
        i18n: 'nbDomesticNotDomestic',
    },

    VP_229: {
        code: 'VP.229',
        name: 'VP.229',
        i18n: 'popSubRatio',
    },

    VP_003: {
        code: 'VP.003',
        name: 'VP.003',
        i18n: 'nbWrittenComplaintsReceivedDelegatee',
    },

    VP_152: {
        code: 'VP.152',
        name: 'VP.152',
        i18n: 'nbWrittenComplaintsReceivedCollectivity',
    },

    P155_1: {
        code: 'P155.1',
        name: 'P155.1',
        i18n: 'totalNbWrittenComplaints',
    },

    VP_020: {
        code: 'VP.020',
        name: 'VP.020',
        i18n: 'serviceInterruptions',
    },

    DC_177: {
        code: 'DC.177',
        name: 'DC.177',
        i18n: 'amountYearNColl',
    },

    DC_178: {
        code: 'DC.178',
        name: 'DC.178',
        i18n: 'amountYearNDeleg',
    },

    DC_184: {
        code: 'DC.184',
        name: 'DC.184',
        i18n: 'billingPrevYear',
    },

    VP_213: {
        code: 'VP.213',
        name: 'VP.213',
        i18n: 'VATRateApplicable',
    },

    VP_214: {
        code: 'VP.214',
        name: 'VP.214',
        i18n: 'VNFwithdrawals',
    },

    VP_215: {
        code: 'VP.215',
        name: 'VP.215',
        i18n: 'waterAgencyProtection',
    },

    VP_216: {
        code: 'VP.216',
        name: 'VP.216',
        i18n: 'consumptiveUsePerformance',
    },

    VP_219: {
        code: 'VP.219',
        name: 'VP.219',
        i18n: 'otherTaxesFeesApplicable',
    },

    VP_179: {
        code: 'VP.179',
        name: 'VP.179',
        i18n: 'totalAmountTaxesFees',
    },

    VP_077: {
        code: 'VP.077',
        name: 'VP.077',
        i18n: 'networkLinearity',
    },

    VP_059: {
        code: 'VP.059',
        name: 'VP.059',
        i18n: 'volumeProduced',
    },

    VP_060: {
        code: 'VP.060',
        name: 'VP.060',
        i18n: 'volumeImported',
    },

    VP_061: {
        code: 'VP.061',
        name: 'VP.061',
        i18n: 'volumeExported',
    },

    VP_063: {
        code: 'VP.063',
        name: 'VP.063',
        i18n: 'domesticVolumeRecorded',
    },

    VP_201: {
        code: 'VP.201',
        name: 'VP.201',
        i18n: 'nonDmesticvolumeRecorded',
    },

    VP_232: {
        code: 'VP.232',
        name: 'VP.232',
        i18n: 'volumesConsumedRecorded',
    },

    VP_228: {
        code: 'VP.228',
        name: 'VP.228',
        i18n: 'linearDensitySubscribers',
    },

    DC_195: {
        code: 'DC.195',
        name: 'DC.195',
        i18n: 'financialAmountWorkUndertaken',
    },

    VP_140: {
        code: 'VP.140',
        name: 'VP.140',
        i18n: 'linearNetworkRenewal5',
    },

    VP_141: {
        code: 'VP.141',
        name: 'VP.141',
        i18n: 'LinearNetworksRenewed',
    },

    VP_182: {
        code: 'VP.182',
        name: 'VP.182',
        i18n: 'totalOutstandingDebt',
    },

    VP_183: {
        code: 'VP.183',
        name: 'VP.183',
        i18n: 'annualGrossSavings',
    },

    VP_185: {
        code: 'VP.185',
        name: 'VP.185',
        i18n: 'amountInvoicedIncludingTax',
    },

    VP_268: {
        code: 'VP.268',
        name: 'VP.268',
        i18n: 'amountRemainingUnpaid',
    },

    VP_119: {
        code: 'VP.119',
        name: 'VP.119',
        i18n: 'totalAmountDebtWriteOffsAndPayments',
    },

    DC_192: {
        code: 'DC.192',
        name: 'DC.192',
        i18n: 'natureResourcesUsed',
    },

    VP_128: {
        code: 'VP.128',
        name: 'VP.128',
        i18n: 'numberPhysicalChemicalSamplesTaken',
    },

    VP_129: {
        code: 'VP.129',
        name: 'VP.129',
        i18n: 'numberNonCompliantSamplesPhysicalChemistry',
    },

    VP_126: {
        code: 'VP.126',
        name: 'VP.126',
        i18n: 'numberMicrobiologySamples',
    },

    VP_127: {
        code: 'VP.127',
        name: 'VP.127',
        i18n: 'numberNonCompliantSamplesInMicrobiology',
    },

    VP_236: {
        code: 'VP.236',
        name: 'VP.236',
        i18n: 'existenceNetworkPlan',
    },

    VP_237: {
        code: 'VP.237',
        name: 'VP.237',
        i18n: 'existenceAndimplementationProcedure',
    },

    VP_238: {
        code: 'VP.238',
        name: 'VP.238',
        i18n: 'existenceNetworkInventory',
    },

    VP_239: {
        code: 'VP.239',
        name: 'VP.239',
        i18n: 'percentageOfNetworkLength',
    },

    VP_240: {
        code: 'VP.240',
        name: 'VP.240',
        i18n: 'integrationOfNetworkInventoryInformation',
    },

    VP_241: {
        code: 'VP.241',
        name: 'VP.241',
        i18n: 'percentageOfNetworkLengthInventory',
    },

    VP_242: {
        code: 'VP.242',
        name: 'VP.242',
        i18n: 'locationOfAncillaryStructures',
    },

    VP_243: {
        code: 'VP.243',
        name: 'VP.243',
        i18n: 'inventoryUpdatedAtLeastOnce',
    },

    VP_244: {
        code: 'VP.244',
        name: 'VP.244',
        i18n: 'locationOfConnections',
    },

    VP_245: {
        code: 'VP.245',
        name: 'VP.245',
        i18n: 'characteristicsOfTheWaterMeter',
    },

    VP_246: {
        code: 'VP.246',
        name: 'VP.246',
        i18n: 'identificationOfAreasOfWaterLoss',
    },

    VP_247: {
        code: 'VP.247',
        name: 'VP.247',
        i18n: 'UptodateLocationOfOtherInterventions',
    },

    VP_248: {
        code: 'VP.248',
        name: 'VP.248',
        i18n: 'existenceMultiYearPipeRenewalProgram',
    },

    VP_249: {
        code: 'VP.249',
        name: 'VP.249',
        i18n: 'existenceONetworkModeling',
    },

    VP_263: {
        code: 'VP.263',
        name: 'VP.263',
        i18n: 'subtotalPartA',
    },

    VP_264: {
        code: 'VP.264',
        name: 'VP.264',
        i18n: 'subtotalPartAAndB',
    },

    VP_220: {
        code: 'VP.220',
        name: 'VP.220',
        i18n: 'networkServiceVolume',
    },

    VP_221: {
        code: 'VP.221',
        name: 'VP.221',
        i18n: 'volumesConsumedWithoutMetering',
    },

    VP_224: {
        code: 'VP.224',
        name: 'VP.224',
        i18n: 'linearConsumptionIndex',
    },

    VP_225: {
        code: 'VP.225',
        name: 'VP.225',
        i18n: 'averageReturnOverTheLast3Years',
    },

    VP_226: {
        code: 'VP.226',
        name: 'VP.226',
        i18n: 'defaultThresholdYield',
    },

    VP_227: {
        code: 'VP.227',
        name: 'VP.227',
        i18n: 'thresholdYieldForServices',
    },

    VP_231: {
        code: 'VP.231',
        name: 'VP.231',
        i18n: 'averageConsumptionPerSubscriber',
    },

    VP_234: {
        code: 'VP.234',
        name: 'VP.234',
        i18n: 'volumeProducedPlusVolumeImported',
    },

    VP_235: {
        code: 'VP.235',
        name: 'VP.235',
        i18n: 'hasThereBeenSignificantChange',
    },
}